import { ActionTypeEnum } from '../enum/action-type-enum.enum';

export class StatusChange {
    public status:string;
    public reason:string;
    public fileName:string;
    public file:File;
    public fileType:string;
    public userId:string;
    public actionType:ActionTypeEnum;
}
